export default __webpack_public_path__ + "static/media/exportacoes1990_2025.6bd9403b.csv";